import type { NavItem } from './buildNavItems';

const STORAGE_PREFIX = 'momy.web-escola.atalhos';

function chave(idUsuario: number, idEscola: number): string {
  return `${STORAGE_PREFIX}.${idUsuario}.${idEscola}`;
}

/** `null` = usuario ainda nao personalizou (sidebar mostra todos os modulos permitidos). */
export function loadAtalhos(idUsuario: number, idEscola: number): number[] | null {
  try {
    const raw = localStorage.getItem(chave(idUsuario, idEscola));
    if (raw === null) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return null;
    return parsed.filter((v): v is number => typeof v === 'number');
  } catch {
    return null;
  }
}

/** Remove chave legada apos migrar para a API. */
export function clearAtalhosLocal(idUsuario: number, idEscola: number): void {
  localStorage.removeItem(chave(idUsuario, idEscola));
}

export function resolveFavoritos(
  stored: number[] | null,
  todosCodigosPermitidos: number[],
): Set<number> {
  if (stored === null) {
    return new Set(todosCodigosPermitidos);
  }
  const permitidos = new Set(todosCodigosPermitidos);
  return new Set(stored.filter((c) => permitidos.has(c)));
}

/**
 * Sidebar na ordem persistida. Com `stored === null`, usa a ordem do catalogo.
 */
export function filterSidebarAtalhos(items: NavItem[], stored: number[] | null): NavItem[] {
  if (stored === null) {
    return items;
  }
  const byCodigo = new Map(items.map((item) => [item.codigoModulo, item]));
  return stored
    .map((codigo) => byCodigo.get(codigo))
    .filter((item): item is NavItem => item != null);
}

/** Anexa no fim se ainda nao estiver; remove se ja estiver. Preserva ordem restante. */
export function toggleCodigoNaOrdem(ordem: number[], codigo: number): number[] {
  if (ordem.includes(codigo)) {
    return ordem.filter((c) => c !== codigo);
  }
  return [...ordem, codigo];
}
